import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, SalesPortalUserCreateRequest } from 'types';
import { client } from 'utils/api-client';

export default function useSalesPortalCreateUser(): UseMutationResult<
  AxiosResponse<void>,
  AxiosError<ErrorMessage>,
  SalesPortalUserCreateRequest
> {
  const salesPortalCreateUser = (user: SalesPortalUserCreateRequest): Promise<AxiosResponse<void>> => {
    return client.post('sales-portal/users/', user);
  };

  return useMutation(salesPortalCreateUser);
}
